module.exports = __webpack_public_path__ + "assets/img/logo@2x.5fbbf0a3.png";